/* SUNINOVA — UX simulateur : remonte automatiquement au début du formulaire à chaque changement d'étape. */
(function(w,d){'use strict';
function init(){
  d.querySelectorAll('[data-sn-sim]').forEach(function(root){
    if(root.getAttribute('data-sn-autoscroll')==='1')return;
    var count=root.querySelector('[data-sn-count]');
    if(!count)return;
    root.setAttribute('data-sn-autoscroll','1');
    var last=String(count.textContent||'').trim();
    function goTop(){
      var target=root.querySelector('#suninova-simulator')||root;
      var headerOffset=w.innerWidth<=768?82:96;
      var top=target.getBoundingClientRect().top+(w.pageYOffset||d.documentElement.scrollTop)-headerOffset;
      w.requestAnimationFrame(function(){
        w.scrollTo({top:Math.max(0,top),behavior:'smooth'});
      });
    }
    new MutationObserver(function(){
      var now=String(count.textContent||'').trim();
      if(!now||now===last)return;
      last=now;
      setTimeout(goTop,40);
    }).observe(count,{childList:true,subtree:true,characterData:true});
  });
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})(window,document);
